import { IconButton, Tooltip } from '@mui/material'
import ViewIcon from 'icons/ViewIcon';
import { useHref } from 'react-router-dom';
import { colors } from 'styles/colors';

interface Props {
  path: string;
}

export default function ViewActionButton({ path }: Props) {
  const href = useHref(path);

  const handlePress = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(href, '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip title={'View'}>
      <IconButton
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handlePress}
        sx={{
          width: 25,
          height: 25,
          backgroundColor: colors.view,
          borderRadius: '4px',
          padding: 0,
          '&:hover': {
            backgroundColor: colors.view,
          },
        }}
      >
        <ViewIcon size={12} color='white' />
      </IconButton>
    </Tooltip>
  )
}
